import { useRouter } from 'vue-router';
import { useIsNextLayout } from '@/utils/composables/useLayoutVariant';
import { featureFlags } from '@/featureFlags';

/**
 * 管理できる契約がない管理者が、契約・メンバーの画面を開いたときの移動先。
 * 新デザインでは、押せない・移動するよりも「表示できるものがない」と出すほうが分かりやすいという判断で移動しない。
 */
export const useRedirectWithoutManagementContracts = (): (() => void) => {
  const router = useRouter();
  const isNextLayout = useIsNextLayout();

  return () => {
    if (featureFlags.ANDEV_10131_CAPABILITY && isNextLayout) return;
    router.push({ name: 'themeAdmin' });
  };
};
